import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPlaintes } from "../services/admin.plaintes.service";
import { useToast } from "../context/ToastContext";
import PlainteHeader from "../components/plainte/PlainteHeader";
import PlainteTable from "../components/plainte/PlainteTable";
import PlainteDetailsModal from "../components/plainte/PlainteDetailsView";


export default function Plaintes() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [data, setData] = useState({
    data: [],
    last_page: 1,
    current_page: 1,
    total: 0,
  });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    loadPlaintes();
  }, [page, search, statusFilter]);


  async function loadPlaintes() {
    setLoading(true);
    try {
      const filters = { search, status: statusFilter };
      const response = await getPlaintes(page, filters);
      setData(response);
    } catch (err) {
      showToast("Erreur de chargement", "error");
    } finally {
      setLoading(false);
    }
  }

 if (loading && data.data.length === 0) {
  return <div className="loaderContainer">Chargement des plaintes...</div>;
}

  return (
    <div className="page">
      <PlainteHeader
        total={data.total}
        search={search}
        onSearch={(val) => {
          setSearch(val);
          setPage(1);
        }}
        statusFilter={statusFilter}
        onStatusChange={(val) => {
          setStatusFilter(val);
          setPage(1);
        }}
      />


      <div className={loading ? "tableContainer loading" : "tableContainer"}>
        <PlainteTable 
          plaintes={data.data} 
          onView={(p) => navigate(`/plaintes/${p.id}`)} 
        />
      </div>

      <div className="paginationContainer">
        <div className="pagiInfo">
          Page <strong>{page}</strong> sur {data.last_page}
        </div>
        <div className="pagiControls">
          <button
            className="pagiBtn"x    
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Précédent
          </button>
          <button
            className="pagiBtn"
            disabled={page === data.last_page}
            onClick={() => setPage((p) => p + 1)}
          >
            Suivant
          </button>
        </div>
      </div>

      <PlainteDetailsModal tr={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
